<template>
    <b-navbar toggleable="md" class="navbar align-items-center justify-content-between bg-transparent px-2 py-1">

      <b-navbar-brand to="/">
        <logo />
      </b-navbar-brand>
      <Contact class="d-block d-md-none d-lg-none" />
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <Menu class="mx-lg-auto mx-md-auto mx-0 order-1 order-md-0" v-if="!sensorActive"/>
        <div class="mx-lg-auto mx-md-auto mx-0 order-1 order-md-0" v-else></div>
        <div :class="sensorActive ? 'float-right d-md-block d-lg-block d-none' : 'd-md-block d-lg-block d-none'">
          <Contact/>
        </div>
      </b-collapse>

    </b-navbar>
</template>

<script>
import {
  BNavbarBrand,
  BNavbar,
  BNavbarToggle,
  BCollapse,
} from 'bootstrap-vue'
import Logo from './components/Logo.vue'
import Menu from './components/Menu.vue'
import Contact from './components/Contact.vue'

export default {
  name: 'Navbar',
  components: {
    BNavbar,
    BNavbarBrand,
    BNavbarToggle,
    BCollapse,
    Logo,
    Menu,
    Contact,
  },
  data() {
    return {
      sensorActive: false,
    }
  },
  created() {
    if (this.$route.query.sensor && this.$route.query.sensor === 'active') {
      this.sensorActive = true
    } else {
      this.sensorActive = false
    }
  },
}
</script>

<style>
.navbar-light .navbar-toggler {
  border-color: transparent;
}
.navbar-toggler-icon {
  width: 1em !important;
  height: 1em !important;
}

</style>
